import Header from "@components/Header/Header"
import { useNavigate } from "react-router"
import Switch from "@components/Switch/Switch"
import { useBiometricsStore } from "@stores/biometricsStore"
import { useTranslation } from "react-i18next"
import { Container, SettingItem, SettingLabel, NotificationContainer } from "./Biometrics.styles"
import { getPlatform, Biometrics as TelegramBiometrics } from '@lib/telegram'
import { useEffect } from "react"
import AlertBox from "@components/AlertBox/AlertBox"

const Biometrics = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { isEnabled, toggleBiometrics } = useBiometricsStore()

  useEffect(() => {
    if (!TelegramBiometrics.isAccessGranted() || !TelegramBiometrics.IsTokenSaved()) {
      TelegramBiometrics.requestBiometricsAccess()
    }
  }, [TelegramBiometrics.isAccessGranted, TelegramBiometrics.IsTokenSaved])

  return (
    <Container>
      <Header 
        title={t('authentication.biometrics.title').toUpperCase()}
        showBackButton={true}
        onBackClick={() => navigate('/security')}
      />
      <SettingItem>
        <SettingLabel>
          {t('authentication.biometrics.enableButton')}
        </SettingLabel>

        <Switch
          isActive={isEnabled}
          onChange={toggleBiometrics}
        />
      </SettingItem>
      {getPlatform()?.toLocaleLowerCase() === 'android' && 
      !TelegramBiometrics.IsTokenSaved() && 
        <NotificationContainer>
          <AlertBox
            alertText={t('authentication.biometrics.needAccess')}
            onClick={TelegramBiometrics.openSettings}
            actionText={t('authentication.biometrics.openSettings')}
          />
        </NotificationContainer>
      }
      {getPlatform()?.toLocaleLowerCase() === 'android' && 
      !TelegramBiometrics.isAccessGranted() && 
        <NotificationContainer>
          <AlertBox
            alertText={t('authentication.biometrics.needAccessWithInstructions')}
          />
        </NotificationContainer>
      }
    </Container>
  )
}

export default Biometrics